import React from 'react';
import { Link } from 'react-router-dom';
import './FooterSelectionScreen.css';

const FooterSelectionScreen = ({ className, bottomOffset = 0 }) => {
  return (
    <footer
      className={`site-footer-selection-screen ${className || ''}`}
      style={{ bottom: `${bottomOffset}px` }}
    >
      <div className="footer-links">
        <Link to="/about" className="footer-link">About Us</Link>
        <span className="footer-link-separator">|</span>
        <Link to="/contact" className="footer-link">Contact</Link>
        <span className="footer-link-separator">|</span>
        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
      </div>
      <p className="footer-copyright">&copy; {new Date().getFullYear()} Wunner. All rights reserved.</p>
    </footer>
  );
};

export default FooterSelectionScreen;